import { useLogout } from "@/api/AppApi/services/auth";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useLogout as useLogoutHook } from "./useLogout";
export const useAccount = () => {
  const router = useRouter();
  const { logout: logoutHook } = useLogoutHook();
  const logoutPost = useLogout({ onSuccess: () => {}, onError: () => {} });
  const logout = () => {
    logoutPost.mutate();
    setTimeout(() => {
      logoutHook();
      router.push("/");
    }, 300);
  };
  return {
    logout,
  };
};
